import React from "react";
import "./BlogSection.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const blogs = [
  {
    id: 1,
    title: "Top SEO and Digital Marketing Services to Watch in 2025",
    slug: "top-seo-services-to-watch-in-2025",
    snippet:
      "Stay ahead with the latest SEO practices that will dominate the search engines this year.",
    image: "https://source.unsplash.com/600x400/?seo,technology",
  },
  {
    id: 2,
    title: "Digital Marketing Strategies for Startups",
    slug: "digital-marketing-strategies-for-startups",
    snippet:
      "Learn how small businesses can create big impacts with smart digital marketing.",
    image: "https://source.unsplash.com/600x400/?digital-marketing,startup",
  },
  {
    id: 3,
    title: "Google Algorithm Updates Explained",
    slug: "google-algorithm-updates-explained",
    snippet:
      "Understand how Google's latest updates affect your website rankings.",
    image: "https://source.unsplash.com/600x400/?google,algorithm",
  },
  {
    id: 4,
    title: "Top SEO and Digital Marketing Services in Mumbai",
    slug: "top-seo-services-in-mumbai",
    snippet: "Explore how SEO is transforming businesses in Mumbai.",
    image: "https://source.unsplash.com/600x400/?mumbai,seo",
  },
  {
    id: 5,
    title: "Top SEO and Digital Marketing Services in Pune",
    slug: "top-seo-services-in-pune",
    snippet: "Discover SEO best practices helping Pune businesses grow.",
    image: "https://source.unsplash.com/600x400/?pune,seo",
  },
  {
    id: 6,
    title: "Top SEO and Digital Marketing Services in Nagpur",
    slug: "top-seo-services-in-nagpur",
    snippet: "Learn top SEO strategies that work in Nagpur.",
    image: "https://source.unsplash.com/600x400/?nagpur,seo",
  },
  {
    id: 7,
    title: "Top SEO and Digital Marketing Services in Nashik",
    slug: "top-seo-services-in-nashik",
    snippet: "SEO services for Nashik's growing digital business community.",
    image: "https://source.unsplash.com/600x400/?nashik,seo",
  },
  {
    id: 8,
    title: "Top SEO and Digital Marketing Services in Thane",
    slug: "top-seo-services-in-thane",
    snippet: "See how SEO is evolving for Thane-based businesses.",
    image: "https://source.unsplash.com/600x400/?thane,seo",
  },
  {
    id: 9,
    title:
      "Top SEO and Digital Marketing Services in Chhatrapati Sambhajinagar(Aurangabad)",
    slug: "top-seo-services-in-chhatrapati-sambhajinagar-aurangabad",
    snippet:
      "Chhatrapati Sambhajinagar(Aurangabad) is embracing SEO in unique ways—learn more.",
    image: "https://source.unsplash.com/600x400/?aurangabad,seo",
  },
  {
    id: 10,
    title: "Top SEO and Digital Marketing Services in Solapur",
    slug: "top-seo-services-in-solapur",
    snippet: "Solapur’s local SEO growth is on the rise.",
    image: "https://source.unsplash.com/600x400/?solapur,seo",
  },
  {
    id: 11,
    title: "Top SEO and Digital Marketing Services in Kolhapur",
    slug: "top-seo-services-in-kolhapur",
    snippet: "SEO services that work well in Kolhapur.",
    image: "https://source.unsplash.com/600x400/?kolhapur,seo",
  },
  {
    id: 12,
    title: "Top SEO and Digital Marketing Services in Amravati",
    slug: "top-seo-services-in-amravati",
    snippet: "Digital trends & SEO services shaping Amravati.",
    image: "https://source.unsplash.com/600x400/?amravati,seo",
  },
  {
    id: 13,
    title: "Top SEO and Digital Marketing Services in Sangli",
    slug: "top-seo-services-in-sangli",
    snippet: "Explore Sangli’s growing SEO landscape.",
    image: "https://source.unsplash.com/600x400/?sangli,seo",
  },
  {
    id: 14,
    title: "Top SEO and Digital Marketing Services in Navi Mumbai",
    slug: "top-seo-services-in-navi-mumbai",
    snippet: "Smart local SEO for Navi Mumbai businesses.",
    image: "https://source.unsplash.com/600x400/?navimumbai,seo",
  },
  {
    id: 15,
    title: "Top SEO and Digital Marketing Services in Latur",
    slug: "top-seo-services-in-latur",
    snippet: "How SEO is driving digital growth in Latur.",
    image: "https://source.unsplash.com/600x400/?latur,seo",
  },
  {
    id: 16,
    title: "Top SEO and Digital Marketing Services in Jalgaon",
    slug: "top-seo-services-in-jalgaon",
    snippet: "SEO growth opportunities for Jalgaon businesses.",
    image: "https://source.unsplash.com/600x400/?jalgaon,seo",
  },
  {
    id: 17,
    title: "Top SEO and Digital Marketing Services in Ahmednagar",
    slug: "top-seo-services-in-ahmednagar",
    snippet: "Ahmednagar’s businesses are going digital with SEO.",
    image: "https://source.unsplash.com/600x400/?ahmednagar,seo",
  },
  {
    id: 18,
    title: "Top SEO and Digital Marketing Services in Satara",
    slug: "top-seo-services-in-satara",
    snippet: "What works best for SEO in Satara.",
    image: "https://source.unsplash.com/600x400/?satara,seo",
  },
  {
    id: 19,
    title: "Top SEO and Digital Marketing Services in Akola",
    slug: "top-seo-services-in-akola",
    snippet: "Learn how Akola brands can benefit from SEO.",
    image: "https://source.unsplash.com/600x400/?akola,seo",
  },
  {
    id: 20,
    title: "Top SEO and Digital Marketing Services in Chandrapur",
    slug: "top-seo-services-in-chandrapur",
    snippet: "Digital marketing growth through SEO in Chandrapur.",
    image: "https://source.unsplash.com/600x400/?chandrapur,seo",
  },
  {
    id: 21,
    title: "Top SEO and Digital Marketing Services in Wardha",
    slug: "top-seo-services-in-wardha",
    snippet: "Wardha’s digital economy is growing—stay ahead with SEO.",
    image: "https://source.unsplash.com/600x400/?wardha,seo",
  },
  {
    id: 22,
    title: "Top SEO and Digital Marketing Services in Beed",
    slug: "top-seo-services-in-beed",
    snippet: "Beed is emerging in digital—SEO is key.",
    image: "https://source.unsplash.com/600x400/?beed,seo",
  },
  {
    id: 23,
    title: "Top SEO and Digital Marketing Services in Nanded",
    slug: "top-seo-services-in-nanded",
    snippet: "Explore Nanded’s local SEO developments.",
    image: "https://source.unsplash.com/600x400/?nanded,seo",
  },
  {
    id: 24,
    title: "Top SEO and Digital Marketing Services in Osmanabad",
    slug: "top-seo-services-in-osmanabad",
    snippet: "SEO tools and tactics for Osmanabad businesses.",
    image: "https://source.unsplash.com/600x400/?osmanabad,seo",
  },
  {
    id: 25,
    title: "Top SEO and Digital Marketing Services in Bhandara",
    slug: "top-seo-services-in-bhandara",
    snippet: "Bhandara is adopting smart digital SEO strategies.",
    image: "https://source.unsplash.com/600x400/?bhandara,seo",
  },
  {
    id: 26,
    title: "Top SEO and Digital Marketing Services in Gondia",
    slug: "top-seo-services-in-gondia",
    snippet: "Get noticed in Gondia using these SEO tips.",
    image: "https://source.unsplash.com/600x400/?gondia,seo",
  },
  {
    id: 27,
    title: "Top SEO and Digital Marketing Services in Yavatmal",
    slug: "top-seo-services-in-yavatmal",
    snippet: "SEO growth in Yavatmal’s local economy.",
    image: "https://source.unsplash.com/600x400/?yavatmal,seo",
  },
  {
    id: 28,
    title: "Top SEO and Digital Marketing Services in Dhule",
    slug: "top-seo-services-in-dhule",
    snippet: "How Dhule businesses can benefit from SEO in 2025.",
    image: "https://source.unsplash.com/600x400/?dhule,seo",
  },
  {
    id: 29,
    title: "Top SEO and Digital Marketing Services in Buldhana",
    slug: "top-seo-services-in-buldhana",
    snippet: "Smart SEO strategies for Buldhana entrepreneurs.",
    image: "https://source.unsplash.com/600x400/?buldhana,seo",
  },
  {
    id: 30,
    title: "Top SEO and Digital Marketing Services in Parbhani",
    slug: "top-seo-services-in-parbhani",
    snippet: "Parbhani businesses can grow with local SEO efforts.",
    image: "https://source.unsplash.com/600x400/?parbhani,seo",
  },
  {
    id: 31,
    title: "Top SEO and Digital Marketing Services in Hingoli",
    slug: "top-seo-services-in-hingoli",
    snippet: "Hingoli’s digital push can benefit from SEO.",
    image: "https://source.unsplash.com/600x400/?hingoli,seo",
  },
  {
    id: 32,
    title: "Top SEO and Digital Marketing Services in Washim",
    slug: "top-seo-services-in-washim",
    snippet: "SEO in Washim: A new growth avenue for local firms.",
    image: "https://source.unsplash.com/600x400/?washim,seo",
  },
  {
    id: 33,
    title: "Top SEO and Digital Marketing Services in Palghar",
    slug: "top-seo-services-in-palghar",
    snippet: "Palghar is entering the digital space—SEO helps lead.",
    image: "https://source.unsplash.com/600x400/?palghar,seo",
  },
  {
    id: 34,
    title: "Top SEO and Digital Marketing Services in Jalna",
    slug: "top-seo-services-in-jalna",
    snippet: "How SEO can boost businesses in Jalna.",
    image: "https://source.unsplash.com/600x400/?jalna,seo",
  },
  {
    id: 35,
    title: "Top SEO and Digital Marketing Services in Raigad",
    slug: "top-seo-services-in-raigad",
    snippet: "Raigad’s growing digital landscape needs SEO focus.",
    image: "https://source.unsplash.com/600x400/?raigad,seo",
  },
  {
    id: 36,
    title: "Top SEO and Digital Marketing Services in Ratnagiri",
    slug: "top-seo-services-in-ratnagiri",
    snippet: "Make your business searchable in Ratnagiri with SEO.",
    image: "https://source.unsplash.com/600x400/?ratnagiri,seo",
  },
  {
    id: 37,
    title: "Top SEO and Digital Marketing Services in Sindhudurg",
    slug: "top-seo-services-in-sindhudurg",
    snippet: "Explore how SEO is gaining traction in Sindhudurg.",
    image: "https://source.unsplash.com/600x400/?sindhudurg,seo",
  },
  {
    id: 38,
    title: "Top SEO and Digital Marketing Services in Gondalgaon",
    slug: "top-seo-services-in-gondalgaon",
    snippet: "SEO is now reaching even micro-cities like Gondalgaon.",
    image: "https://source.unsplash.com/600x400/?city,seo",
  },
  {
    id: 39,
    title: "Top SEO and Digital Marketing Services in Malkapur",
    slug: "top-seo-services-in-malkapur",
    snippet: "Digital is booming in Malkapur—stay competitive with SEO.",
    image: "https://source.unsplash.com/600x400/?malkapur,seo",
  },
  {
    id: 40,
    title: "Top SEO and Digital Marketing Services in Dombivli",
    slug: "top-seo-services-in-dombivli",
    snippet: "Dombivli companies are gaining traction with local SEO.",
    image: "https://source.unsplash.com/600x400/?dombivli,seo",
  },
  {
    id: 41,
    title: "Top SEO and Digital Marketing Services in Ulhasnagar",
    slug: "top-seo-services-in-ulhasnagar",
    snippet: "Ulhasnagar is on the SEO map—see what’s working.",
    image: "https://source.unsplash.com/600x400/?ulhasnagar,seo",
  },
  {
    id: 42,
    title: "Top SEO and Digital Marketing Services in Panvel",
    slug: "top-seo-services-in-panvel",
    snippet: "SEO growth trends in Panvel's local market.",
    image: "https://source.unsplash.com/600x400/?panvel,seo",
  },
  {
    id: 43,
    title: "Top SEO and Digital Marketing Services in Kalyan",
    slug: "top-seo-services-in-kalyan",
    snippet: "How Kalyan-based businesses can dominate with SEO.",
    image: "https://source.unsplash.com/600x400/?kalyan,seo",
  },
];

const BlogSection = () => {
  return (
    <section className="blog-section">
      <Helmet>
        <title>
          Digital Marketing & SEO Blog – Tips, Trends & Guides | Just SEO
        </title>
        <meta
          name="description"
          content="Stay ahead with the latest in SEO, digital marketing, and online growth strategies. Explore expert insights, trends, and actionable tips from Just SEO’s blog."
        />
        <meta
          name="keywords"
          content="AI SEO, artificial intelligence SEO, machine learning SEO, ChatGPT for SEO, AI content optimization, Google Bard SEO, NLP for SEO, AI keyword research, automated SEO, predictive SEO, AI backlink analysis, SEO automation tools, AI-powered rankings, generative AI SEO, AI meta descriptions, SEO machine learning,AI SEO tools, ChatGPT SEO prompts, Google Gemini SEO, multilingual AI SEO, AI content detection, AI for technical SEO, AI-powered backlinks, AI SERP analysis, AI for featured snippets, AI SEO audits, AI for local SEO, AI eCommerce SEO, AI video SEO, AI for voice search, AI content scoring, SEO machine learning models, neural matching optimization, AI for zero-click SEO, SEO services, digital marketing agency, search engine optimization, on-page SEO, off-page SEO, local SEO, eCommerce SEO, Google ranking, SEO expert, PPC advertising, social media marketing, content marketing, email marketing, YouTube SEO, voice search SEO, AI SEO, backlink building, keyword research, technical SEO, mobile SEO, Shopify SEO, WordPress SEO, SEO audit, Google Ads, Facebook Ads, LinkedIn marketing, SEO consultant, affordable SEO services, SEO for small business,content marketing, email marketing, influencer marketing, affiliate marketing, Google Ads, Facebook Ads, best SEO strategies 2024, how to improve Google ranking, SEO for small businesses, e-commerce SEO tips, voice search optimization, AI in digital marketing, Meta ads management, YouTube SEO techniques, mobile SEO best practices, SEO vs SEM,Search engine optimization,SEO services,SEO agency,SEO consultant,SEO expert,SEO company,SEO audit,SEO tools,Google ranking,Organic search traffic,Backlink building,Broken link building,Digital PR for SEO,Page speed optimization,SEO near me,Voice search optimization,Mobile-first indexing,Global SEO strategy,Multiregional SEO,How to improve SEO ranking, Real estate lead generation, Healthcare marketing,How to get backlinks naturally,Google Search Console,Google Analytics 4 (GA4),Rank tracking,Click-through rate (CTR),Bounce rate SEO,Dwell time,Organic impressions,Search query reports,Cannibalization tracking,SEO KPI dashboard,AI tools for digital marketing,AI tools for digital marketing"
        />
        <meta property="og:title" content="Digital Marketing & SEO Blog – Tips, Trends & Guides | Just SEO" />
        <meta
          property="og:image"
          content="https://justseo.in/faviconcopy.png"
        />
         <meta property="og:title" content="Digital Marketing & SEO Blog – Tips, Trends & Guides | Just SEO" />
        <meta property="og:url" content="https://justseo.in/blogs" />
        <meta name="robots" content="index, follow" />
        
      </Helmet>
      <h2 className="blog-heading">Latest Blogs on SEO & Digital Marketing</h2>
      <div className="blog-container">
        {blogs.map((blog) => (
          <div key={blog.id} className="blog-card">
            {/* <img src={blog.image} alt={blog.title} className="blog-image" /> */}
            <div className="blog-content">
              <h3 className="blog-title">{blog.title}</h3>
              <p className="blog-snippet">{blog.snippet}</p>
              <a href={`/blog/${blog.slug}`} className="read-more">
                Read More →
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogSection;
